<template>
  <div>
    <div>
      <div class="row col-12 items-center q-mb-sm">
        <div
          class="row col-12 q-ml-md text-brand-5 text-weight-bold q-mb-md titulo-tabela"
        >
          Transferências Criadas
        </div>
        <div class="row col-12 q-gutter-sm text-brand-5 text-weight-bold">
          <div
            v-if="tipoTransferencia == 'transferencia_externa'"
            class="col-md col-xs-6"
          >
            <div
              class="col"
              v-if="tipoTranferenciaExterna == 'origemFornecedor'"
            >
              <div class="titulo-input">Unidade Origem</div>
              <SelecaoUnidade
                @enviarUnidade="receberUnidadeOrigem"
                :resetar="resetarFiltros"
              />
            </div>
            <div class="col" v-else>
              <div class="titulo-input">Fornecedor Origem</div>
              <SelecaoFornecedor
                :desabilitado="true"
                :unidadeId="dados.destino.id"
                :resetar="resetarFiltros"
                @enviarFornecedor="receberFornecedorOrigem"
              />
            </div>
          </div>
          <div
            v-if="tipoTransferencia == 'transferencia_externa'"
            class="col-md col-xs-5"
          >
            <div
              class="col"
              v-if="tipoTranferenciaExterna == 'origemFornecedor'"
            >
              <div class="titulo-input">Fornecedor Destino</div>
              <SelecaoFornecedor
                :desabilitado="true"
                :unidadeId="dados.origem.id"
                :resetar="resetarFiltros"
                @enviarFornecedor="receberFornecedorDestino"
              />
            </div>
            <div class="col" v-else>
              <div class="titulo-input">Unidade Destino</div>
              <SelecaoUnidade
                @enviarUnidade="receberUnidadeDestino"
                :resetar="resetarFiltros"
              />
            </div>
          </div>
          <div
            v-if="tipoTransferencia == 'transferencia_interna'"
            class="col-md col-xs-6"
          >
            <div class="titulo-input">Unidade Origem</div>
            <SelecaoUnidade
              @enviarUnidade="receberUnidadeOrigem"
              :resetar="resetarFiltros"
            />
          </div>
          <div
            v-if="tipoTransferencia == 'transferencia_interna'"
            class="col-md col-xs-5"
          >
            <div class="titulo-input">Unidade Destino</div>
            <SelecaoUnidade
              @enviarUnidade="receberUnidadeDestino"
              :resetar="resetarFiltros"
            />
          </div>
          <div class="col-md col-xs-6">
            <div class="titulo-input">Status</div>
            <q-select
              class="input"
              behavior="menu"
              v-model="filtros.status"
              dense
              outlined
              label="Selecione o Status"
              label-color="grey-6"
              :options="options.status"
            />
          </div>
          <div class="col-md col-xs-5">
            <div class="titulo-input">Nº Transferência</div>
            <q-input
              label="Digite o Numero"
              label-color="grey-6"
              class="input"
              v-model="filtros.numero"
              dense
              outlined
            />
          </div>
        </div>
        <div
          class="row col-9 q-gutter-sm q-mt-sm text-brand-5 text-weight-bold"
        >
          <div class="col-md col-xs-6">
            <div class="titulo-input">Data Inicial</div>
            <q-input
              dense
              class="input"
              label="Selecione a Data Inicial"
              label-color="grey-6"
              outlined
              v-model="filtros.dataCriacaoInicial"
              mask="##/##/####"
              input-debounce="300"
              :rules="[
                (val) =>
                  val == '' || val.length == 10 || 'Digite a Data Completa',
              ]"
            >
              <template v-slot:append>
                <q-icon name="event" class="cursor-pointer">
                  <q-popup-proxy
                    cover
                    transition-show="scale"
                    transition-hide="scale"
                  >
                    <q-date
                      :locale="myLocale"
                      v-model="dataFiltro.criacaoInicial"
                      mask="DD/MM/YYYY"
                      :rules="[
                        (val) =>
                          val == '' ||
                          val.length == 10 ||
                          'Digite a Data Completa',
                      ]"
                    >
                      <div class="row items-center justify-end">
                        <q-btn
                          v-close-popup
                          label="Fechar"
                          color="primary"
                          flat
                        />
                      </div>
                    </q-date>
                  </q-popup-proxy>
                </q-icon>
              </template>
            </q-input>
          </div>

          <div class="col-md col-xs-6">
            <div class="titulo-input">Data Final</div>
            <q-input
              dense
              class="input"
              label="Selecione a Data Final"
              label-color="grey-6"
              outlined
              v-model="filtros.dataCriacaoFinal"
              mask="##/##/####"
              input-debounce="300"
              :rules="[
                (val) =>
                  val == '' || val.length == 10 || 'Digite a Data Completa',
              ]"
            >
              <template v-slot:append>
                <q-icon name="event" class="cursor-pointer">
                  <q-popup-proxy
                    cover
                    transition-show="scale"
                    transition-hide="scale"
                  >
                    <q-date
                      :locale="myLocale"
                      v-model="dataFiltro.criacaoFinal"
                      mask="DD/MM/YYYY"
                      :rules="[
                        (val) =>
                          val == '' ||
                          val.length == 10 ||
                          'Digite a Data Completa',
                      ]"
                    >
                      <div class="row items-center justify-end">
                        <q-btn
                          v-close-popup
                          label="Fechar"
                          color="primary"
                          flat
                        />
                      </div>
                    </q-date>
                  </q-popup-proxy>
                </q-icon>
              </template>
            </q-input>
          </div>

          <div class="col-md col-xs-5">
            <div class="titulo-input">Patrimônio</div>
            <q-input
              label="Digite o Numero"
              label-color="grey-6"
              class="input"
              v-model="filtros.patrimonio"
              dense
              outlined
            />
          </div>
          <div class="flex items-end">
            <q-btn
              label="Limpar Filtros"
              icon="filter_alt_off"
              no-caps
              style="border-radius: 8px; margin-bottom: 23px"
              color="brand-2"
              @click="limparFiltrosFunc()"
            />
          </div>
        </div>
      </div>

      <q-linear-progress v-if="loading" indeterminate size="3px" />
      <q-table
        :columns="columns"
        :rows="listaTransferenciaCriada"
        :hide-bottom="!listaTransferenciaCriada?.length == 0"
        flat
        dense
        no-data-label="Nenhuma Transferência Criada"
        :rows-per-page-options="[0]"
        :class="{ 'my-sticky-dynamic': !mobile }"
        @request="handleRequest"
        binary-state-sort
        v-model:pagination="pagination"
        :grid="mobile"
      >
        <template v-slot:item="props">
          <div class="q-pa-xs row col-12">
            <q-card class="container-grid-table col-12">
              <div class="q-pa-sm">
                <div class="row col-12 items-center">
                  <div class="col">
                    <div class="row col-12 items-center">
                      <strong class="q-mr-xs">Numero Transferência:</strong>
                      <span> {{ props.row.numero }}</span>
                    </div>
                    <div class="row col-12 items-center">
                      <strong class="q-mr-xs">Origem:</strong>
                      <span>
                        {{
                          props.row.unidadeNomeOrigem ||
                          props.row.fornecedorNomeOrigem
                        }}</span
                      >
                    </div>
                    <div class="row col-12 items-center">
                      <strong class="q-mr-xs">Destino:</strong>
                      <span> {{ props.row.unidadeIdDestino }}</span>
                    </div>
                    <div class="row col-12 items-center">
                      <strong class="q-mr-xs">Status:</strong>
                      <div class="row col no-wrap align items-center">
                        <span
                          v-if="props.row.status == 'criada'"
                          class="elipse q-mr-xs"
                          style="background: #ffff00"
                        ></span>
                        <span
                          v-if="props.row.status == 'cancelada'"
                          class="elipse q-mr-sm"
                          style="background: #2d3e6e"
                        ></span>
                        <span
                          v-if="props.row.status == 'enviada'"
                          class="elipse q-mr-xs"
                          style="background: #0000ff"
                        ></span>
                        <span
                          v-if="props.row.status == 'recebida'"
                          class="elipse q-mr-xs"
                          style="background: #00ff00"
                        ></span>
                        <span
                          v-if="props.row.status == 'recebida_parcial'"
                          class="elipse q-mr-xs"
                          style="background: #ffa500"
                        ></span>
                        <span
                          v-if="props.row.status == 'rejeitada'"
                          class="elipse q-mr-xs"
                          style="background: #ff0000"
                        ></span>
                        <div
                          v-if="props.row.status == 'criada'"
                          style="width: fit-content"
                          class="text-black"
                        >
                          {{ "Criada" }}
                        </div>
                        <div
                          v-if="props.row.status == 'enviada'"
                          style="width: fit-content"
                          class="text-black"
                        >
                          {{ "Enviada" }}
                        </div>
                        <div
                          v-if="props.row.status == 'recebida'"
                          style="width: fit-content"
                          class="text-black"
                        >
                          {{ "Recebida" }}
                        </div>
                        <div
                          v-if="props.row.status == 'recebida_parcial'"
                          style="width: fit-content"
                          class="text-black"
                        >
                          {{ "Recebida Parcialmente" }}
                        </div>
                        <div
                          v-if="props.row.status == 'rejeitada'"
                          style="width: fit-content"
                          class="text-black"
                        >
                          {{ "Rejeitada" }}
                        </div>
                        <div
                          v-if="props.row.status == 'cancelada'"
                          style="width: fit-content"
                          class="text-black"
                        >
                          {{ "Cancelada" }}
                        </div>
                      </div>
                      <div class="row col-12 items-center">
                        <strong class="q-mr-xs">Data Criação:</strong>
                        <span>
                          {{
                            props.row.criadoEm
                              .split(" ")[0]
                              .split("-")
                              .reverse()
                              .join("/")
                          }}</span
                        >
                      </div>
                      <div class="row col-12 items-center">
                        <strong class="q-mr-xs">Criado Por:</strong>
                        <span> {{ props.row.criador }}</span>
                      </div>
                    </div>
                  </div>
                  <div class="col">
                    <div class="row col-12 items-center justify-end">
                      <div v-if="tipoTransferencia === 'transferencia_interna'">
                        <router-link
                          :to="{
                            name: 'ferramentaria-detalhe-transferencia-interna',
                            params: {
                              transferenciaId: props.row.transferenciaUuid,
                            },
                          }"
                        >
                          <q-btn color="secondary" icon="article" round flat />
                        </router-link>
                      </div>
                      <div v-else>
                        <router-link
                          :to="{
                            name: 'ferramentaria-detalhe-transferencia-externa',
                            params: {
                              transferenciaId: props.row.transferenciaUuid,
                            },
                          }"
                        >
                          <q-btn color="secondary" icon="article" round flat />
                        </router-link>
                      </div>
                      <div>
                        <q-btn
                          icon="delete"
                          flat
                          :disable="props.row.status != 'criada'"
                          color="red"
                          @click="confirm = true"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </q-card>
          </div>
        </template>
        <template v-slot:header="props">
          <q-tr :props="props">
            <q-th v-for="col in props.cols" :key="col.name" :props="props">
              {{ col.label }}
            </q-th>
          </q-tr>
        </template>
        <template v-slot:body="props">
          <q-tr class="text-brand-5 text-weight-bold">
            <q-td>
              {{ props.row.numero }}
            </q-td>
            <q-td>
              {{
                props.row.unidadeNomeOrigem || props.row.fornecedorNomeOrigem
              }}
            </q-td>
            <q-td>
              {{
                props.row.unidadeNomeDestino || props.row.fornecedorNomeDestino
              }}
            </q-td>
            <q-td>
              <div
                :style="
                  props.row.status == 'criada'
                    ? 'width: fit-content; background: #fefed1; padding: 2px 5px;'
                    : props.row.status == 'enviada'
                    ? 'width: fit-content; background: #C5DFF8; padding: 2px 5px;'
                    : props.row.status == 'recebida'
                    ? 'width: fit-content; background: #C3EDC0; padding: 2px 5px;'
                    : props.row.status == 'recebida_parcial'
                    ? 'width: fit-content; background: #F1C27B; padding: 2px 5px;'
                    : props.row.status == 'rejeitada'
                    ? 'width: fit-content; background: #E97777; padding: 2px 5px;'
                    : props.row.status == 'cancelada'
                    ? 'width: fit-content; background: #f8f8f8; padding: 2px 5px;'
                    : ''
                "
                class="row col-12 no-wrap align items-center"
              >
                <span
                  v-if="props.row.status == 'criada'"
                  class="elipse q-mr-sm"
                  style="background: #ffff00"
                ></span>
                <span
                  v-if="props.row.status == 'enviada'"
                  class="elipse q-mr-sm"
                  style="background: #0000ff"
                ></span>
                <span
                  v-if="props.row.status == 'recebida'"
                  class="elipse q-mr-sm"
                  style="background: #00ff00"
                ></span>
                <span
                  v-if="props.row.status == 'recebida_parcial'"
                  class="elipse q-mr-sm"
                  style="background: #ffa500"
                ></span>
                <span
                  v-if="props.row.status == 'rejeitada'"
                  class="elipse q-mr-sm"
                  style="background: #ff0000"
                ></span>
                <span
                  v-if="props.row.status == 'cancelada'"
                  class="elipse q-mr-sm"
                  style="background: #2d3e6e"
                ></span>
                <div
                  v-if="props.row.status == 'criada'"
                  style="width: fit-content"
                  class="text-black text-bold"
                >
                  {{ "Criada" }}
                </div>
                <div
                  v-if="props.row.status == 'enviada'"
                  style="width: fit-content"
                  class="text-black text-bold"
                >
                  {{ "Enviada" }}
                </div>
                <div
                  v-if="props.row.status == 'recebida'"
                  style="width: fit-content"
                  class="text-black text-bold"
                >
                  {{ "Recebida" }}
                </div>
                <div
                  v-if="props.row.status == 'recebida_parcial'"
                  style="width: fit-content"
                  class="text-black text-bold"
                >
                  {{ "Recebida Parcialmente" }}
                </div>
                <div
                  v-if="props.row.status == 'rejeitada'"
                  style="width: fit-content"
                  class="text-black text-bold"
                >
                  {{ "Rejeitada" }}
                </div>
                <div
                  v-if="props.row.status == 'cancelada'"
                  style="width: fit-content"
                  class="text-black text-bold"
                >
                  {{ "Cancelada" }}
                </div>
              </div>
            </q-td>
            <q-td>
              {{
                props.row.criadoEm.split(" ")[0].split("-").reverse().join("/")
              }}
            </q-td>
            <q-td>
              {{ props.row.criador }}
            </q-td>
            <q-td>
              <div v-if="tipoTransferencia === 'transferencia_interna'">
                <router-link
                  :to="{
                    name: 'ferramentaria-detalhe-transferencia-interna',
                    params: {
                      transferenciaId: props.row.transferenciaUuid,
                    },
                  }"
                >
                  <q-btn color="secondary" icon="article" round flat />
                </router-link>
              </div>
              <div v-else>
                <router-link
                  :to="{
                    name: 'ferramentaria-detalhe-transferencia-externa',
                    params: {
                      transferenciaId: props.row.transferenciaUuid,
                    },
                  }"
                >
                  <q-btn color="secondary" icon="article" round flat />
                </router-link>
              </div>
            </q-td>
            <q-td>
              <div>
                <q-btn
                  color="red"
                  icon="delete"
                  round
                  flat
                  :disable="props.row.status != 'criada'"
                  @click="
                    (confirm = true),
                      (transferenciaUuid = props.row.transferenciaUuid)
                  "
                />
              </div>
            </q-td>
          </q-tr>
        </template>
      </q-table>
      <div
        v-if="listaTransferenciaCriada?.length > 0"
        class="row justify-center q-mt-md"
      >
        <q-pagination
          :disable="disable"
          v-model="pagination.page"
          color="brand-5"
          active-color="secondary"
          active-text-color="white"
          :max="pagesNumber"
          :max-pages="5"
          :boundary-numbers="false"
          :direction-links="true"
          :size="mobile ? 'md' : 'sm'"
        />
      </div>
    </div>
    <q-dialog v-model="confirm" persistent>
      <q-card
        class="q-pa-sm container-modal-excluir text-brand-5 text-weight-bolder q-pa-xl"
      >
        <q-card-section class="row col-12 justify-center">
          <span class="texto-excluir-pai"
            >TEM CERTEZA QUE DESEJA CANCELAR?</span
          >
          <span class="texto-excluir-filho text-brand-5 q-mt-md q-mb-lg">
            Ao clicar em SIM você estará cancelando por definitivo a
            transferência</span
          >
        </q-card-section>

        <div class="row col-12 justify-center">
          <q-btn
            no-caps
            label="SIM"
            color="positive"
            v-close-popup
            class="btn-excluir"
            icon="check_circle_outline"
            @click="cancelarTransferencia()"
          />
          <q-btn
            icon="cancel"
            no-caps
            label="NÃO"
            color="negative"
            class="btn-excluir q-ml-md"
            v-close-popup
          />
        </div>
      </q-card>
    </q-dialog>
  </div>
</template>

<script>
import { onMounted, ref, computed, watch } from "vue";
import { useStore } from "vuex";
import { useQuasar } from "quasar";
import { watchDebounced } from "@vueuse/core";
import SelecaoFornecedor from "./SelecaoFornecedor.vue";
import SelecaoUnidade from "./SelecaoUnidade.vue";

const columns = [
  {
    name: "numeroTransferencia",
    label: "Nº Transferência",
    align: "left",
  },
  {
    name: "origem",
    label: "Origem",
    align: "left",
  },
  {
    name: "destino",
    label: "Destino",
    align: "left",
  },
  {
    name: "status",
    label: "Status",
    align: "left",
    sortable: true,
  },
  {
    name: "dataCriacao",
    label: "Data Criação",
    align: "left",
  },
  {
    name: "criadoPor",
    label: "Criado Por",
    align: "left",
  },
  {
    name: "detalhe",
    label: "Detalhes",
    align: "left",
  },
  {
    name: "cancelar",
    label: "Cancelar",
    align: "left",
  },
];
export default {
  components: {
    SelecaoFornecedor,
    SelecaoUnidade,
  },
  props: ["tipoTransferencia", "atualizarTabela", "tipoTranferenciaExterna"],
  setup(props) {
    const store = useStore();
    const quasar = useQuasar();

    const listaTransferenciaCriada = ref([]);
    const pagination = ref({
      sortBy: "desc",
      descending: false,
      page: 1,
      rowsPerPage: 10,
      rowsNumber: 6,
    });
    let confirm = ref(false);
    const dataFiltro = ref({ criacaoInicial: "", criacaoFinal: "" });
    const filtros = ref({
      numero: "",
      status: "",
      patrimonio: "",
      dataCriacaoInicial: "",
      dataCriacaoFinal: "",
    });
    let mobile = ref(false);
    let loading = ref(false);
    const valorOrdenacao = ref("");
    const igual = ref(false);
    const dados = ref({
      origem: { nome: "", id: "" },
      destino: { nome: "", id: "" },
    });
    const transferenciaUuid = ref("");
    const options = ref({
      status: [
        { label: "Criada", value: "criada" },
        { label: "Enviada", value: "enviada" },
        { label: "Recebida", value: "recebida" },
        { label: "Recebida Parcialmente", value: "recebida_parcial" },
        { label: "Rejeitada", value: "rejeitada" },
        { label: "Cancelada", value: "cancelada" },
      ],
    });
    let disable = ref(false);
    if (quasar.platform.is.mobile) {
      mobile.value = true;
    }

    const verificarTipoTransferencia = () => {
      if (props.tipoTransferencia === "transferencia_interna") {
        listarTransferenciaInterna();
        return;
      }
      listarTransferenciaExterna();
    };

    const listarTransferenciaInterna = async (
      page = 1,
      perPage = 10,
      ordenacao = { nome: "desc" }
    ) => {
      disable.value = true;
      loading.value = true;
      try {
        const response = await store.dispatch(
          "ferramentaria/listarTransferencia",
          {
            tipo: "interna",
            ordenacao: ordenacao,
            perPage: perPage,
            page: page,
            numero: filtros.value?.numero,
            status: filtros.value?.status?.value,
            patrimonio: filtros.value.patrimonio,
            unidadeIdOrigem: dados.value.origem.id,
            unidadeIdDestino: dados.value.destino.id,
            criadoEmInicial:
              filtros.value.dataCriacaoInicial.length == 10
                ? filtros.value.dataCriacaoInicial
                    .split("/")
                    .reverse()
                    .join("-")
                : "",
            criadoEmFinal:
              filtros.value.dataCriacaoFinal.length == 10
                ? filtros.value.dataCriacaoFinal.split("/").reverse().join("-")
                : "",
          }
        );

        listaTransferenciaCriada.value = response.data.resultado.dados;
        pagination.value.page = response.data.resultado.currentPage;
        pagination.value.perPage = response.data.resultado.perPage;
        pagination.value.rowsNumber = response.data.resultado.total;
      } catch (error) {
        console.log(error);
      } finally {
        disable.value = false;
        loading.value = false;
      }
    };

    const listarTransferenciaExterna = async (
      page = 1,
      perPage = 10,
      ordenacao = { nome: "desc" }
    ) => {
      disable.value = true;
      loading.value = true;
      try {
        const response = await store.dispatch(
          "ferramentaria/listarTransferencia",
          {
            tipo: "externa",
            ordenacao: ordenacao,
            perPage: perPage,
            page: page,
            numero: filtros.value?.numero,
            status: filtros.value?.status?.value,
            patrimonio: filtros.value.patrimonio,
            criadoEmInicial:
              filtros.value.dataCriacaoInicial.length == 10
                ? filtros.value.dataCriacaoInicial
                    .split("/")
                    .reverse()
                    .join("-")
                : "",
            criadoEmFinal:
              filtros.value.dataCriacaoFinal.length == 10
                ? filtros.value.dataCriacaoFinal.split("/").reverse().join("-")
                : "",
            unidadeIdOrigem:
              props.tipoTranferenciaExterna == "origemFornecedor"
                ? dados.value?.origem.id
                : undefined,
            unidadeIdDestino:
              props.tipoTranferenciaExterna == "fornecedorDestino"
                ? dados.value?.destino.id
                : undefined,
            fornecedorIdOrigem:
              props.tipoTranferenciaExterna == "fornecedorDestino"
                ? dados.value?.origem.id
                : undefined,
            fornecedorIdDestino:
              props.tipoTranferenciaExterna == "origemFornecedor"
                ? dados.value?.destino.id
                : undefined,
          }
        );

        listaTransferenciaCriada.value = response.data.resultado.dados;
        pagination.value.page = response.data.resultado.currentPage;
        pagination.value.perPage = response.data.resultado.perPage;
        pagination.value.rowsNumber = response.data.resultado.total;
      } catch (error) {
        console.log(error);
      } finally {
        disable.value = false;
        loading.value = false;
      }
    };

    const cancelarTransferencia = async () => {
      try {
        await store.dispatch("ferramentaria/cancelarTransferencia", {
          cancelador: {
            matricula: store.state.autenticacao.usuarioLogado.id,
            nome: store.state.autenticacao.usuarioLogado.nome,
            funcionario: "sim",
          },
          transferenciaUuid: transferenciaUuid.value,
        });
        verificarTipoTransferencia();
        quasar.notify({
          message: "Transferência cancelada com sucesso.",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      } catch (error) {
        if (error?.response?.data?.erro?.mensagem) {
          quasar.notify({
            message: error?.response?.data?.erro?.mensagem,
            color: "negative",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
        }
        if (error?.response?.data?.erros?.mensagem) {
          quasar.notify({
            message: error?.response?.data?.erros?.mensagem,
            color: "negative",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
        }
      }
    };

    const receberUnidadeOrigem = (value) => {
      if (value === null) {
        dados.value.origem = {
          nome: "",
          id: "",
        };
        return;
      }
      dados.value.origem = {
        nome: value.nome,
        id: value.id,
      };
    };

    const receberUnidadeDestino = (value) => {
      if (value === null) {
        dados.value.destino = {
          nome: "",
          id: "",
        };
        return;
      }
      dados.value.destino = {
        nome: value.nome,
        id: value.id,
      };
    };

    const receberFornecedorOrigem = (value) => {
      if (value === null) {
        dados.value.origem = {
          nome: "",
          id: "",
        };
        return;
      }
      dados.value.origem = {
        nome: value.nome,
        id: value.parceiroId,
      };
    };

    const receberFornecedorDestino = (value) => {
      if (value === null) {
        dados.value.destino = {
          nome: "",
          id: "",
        };
        return;
      }
      dados.value.destino = {
        nome: value.nome,
        id: value.parceiroId,
      };
    };

    watch(
      () => pagination.value.page,
      () => {
        if (props.tipoTransferencia == "transferencia_interna") {
          listarTransferenciaInterna(
            pagination.value.page,
            pagination.value.perPage
          );
          return;
        }
        listarTransferenciaExterna(
          pagination.value.page,
          pagination.value.perPage
        );
      }
    );

    watch(
      () => props.tipoTranferenciaExterna,
      () => {
        dados.value.origem = {
          nome: "",
          id: "",
        };
        dados.value.destino = {
          nome: "",
          id: "",
        };
      }
    );

    watch(
      () => props.atualizarTabela,
      () => {
        verificarTipoTransferencia();
      }
    );

    watch(
      () => dataFiltro.value.criacaoInicial,
      (newValue) => {
        filtros.value.dataCriacaoInicial = newValue;
        if (filtros.value.dataCriacaoInicial.length == 10) {
          verificarTipoTransferencia();
        }
      }
    );

    watch(
      () => dataFiltro.value.criacaoFinal,
      (newValue) => {
        filtros.value.dataCriacaoFinal = newValue;
        if (filtros.value.dataCriacaoFinal.length == 10) {
          verificarTipoTransferencia();
        }
      }
    );

    watchDebounced(
      [
        () => filtros.value.numero,
        () => filtros.value.status,
        () => filtros.value.patrimonio,
        () => dados.value.origem.id,
        () => dados.value.destino.id,
      ],
      () => {
        verificarTipoTransferencia();
      },
      { debounce: 400 }
    );

    onMounted(() => {
      verificarTipoTransferencia();
    });
    const handleRequest = async (value) => {
      const ordenacao = {};

      if (valorOrdenacao.value == value.pagination.sortBy) {
        igual.value = !igual.value;
        ordenacao[
          valorOrdenacao.value == "descricao" ? "nome" : valorOrdenacao.value
        ] = igual.value ? "asc" : "desc";

        pagination.value.sortBy = valorOrdenacao.value;
        pagination.value.descending = igual.value ? false : true;

        if (props.tipoTransferencia == "transferencia_interna") {
          listarTransferenciaInterna(
            pagination.value.page,
            pagination.value.perPage,
            ordenacao
          );
          return;
        }
        listarTransferenciaExterna(
          pagination.value.page,
          pagination.value.perPage,
          ordenacao
        );

        return;
      }

      igual.value = false;

      valorOrdenacao.value = value.pagination.sortBy;
      pagination.value.sortBy = valorOrdenacao.value;
      pagination.value.descending = true;

      ordenacao[
        valorOrdenacao.value == "descricao" ? "nome" : valorOrdenacao.value
      ] = "desc";

      if (props.tipoTransferencia == "transferencia_interna") {
        listarTransferenciaInterna(
          pagination.value.page,
          pagination.value.perPage,
          ordenacao
        );
        return;
      }
      listarTransferenciaExterna(
        pagination.value.page,
        pagination.value.perPage,
        ordenacao
      );
    };
    const resetarFiltros = ref(0);
    const limparFiltrosFunc = () => {
      filtros.value.numero = "";
      filtros.value.status = "";
      filtros.value.patrimonio = "";
      filtros.value.dataCriacaoInicial = "";
      filtros.value.dataCriacaoFinal = "";
      dataFiltro.value.criacaoInicial = "";
      dataFiltro.value.criacaoFinal = "";
      dados.value = {
        origem: { nome: "", id: "" },
        destino: { nome: "", id: "" },
      };
      resetarFiltros.value++;
    };

    return {
      handleRequest,
      columns,
      verificarTipoTransferencia,
      limparFiltrosFunc,
      resetarFiltros,
      listarTransferenciaExterna,
      listarTransferenciaInterna,
      listaTransferenciaCriada,
      confirm,
      filtros,
      disable,
      loading,
      mobile,
      dados,
      receberFornecedorOrigem,
      receberUnidadeDestino,
      cancelarTransferencia,
      pagination,
      dataFiltro,
      myLocale: {
        days: "Domingo_Segunda_Terça_Quarta_Quinta_Sexta_Sábado".split("_"),
        daysShort: "Dom_Seg_Ter_Quar_Quin_Sex_Sáb".split("_"),
        months:
          "Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro".split(
            "_"
          ),
        monthsShort: "Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez".split(
          "_"
        ),
        firstDayOfWeek: 1,
      },
      receberFornecedorDestino,
      transferenciaUuid,
      receberUnidadeOrigem,
      options,
      pagesNumber: computed(() =>
        Math.ceil(pagination.value.rowsNumber / pagination.value.rowsPerPage)
      ),
    };
  },
};
</script>

<style scoped>
.q-table__top,
thead tr:first-child th {
  background-color: #eef3fe;
}

thead tr th {
  position: sticky;
  z-index: 1;
}
thead tr:first-child th {
  top: 0;
}

.q-table--loading thead tr:last-child th {
  top: 48px;
}
.my-sticky-dynamic {
  max-height: 400px;
}
thead tr th {
  position: sticky;
  z-index: 1;
}
thead tr:last-child th {
  top: 48px;
}
thead tr:first-child th {
  top: 0;
}
tbody tr td {
  white-space: pre-wrap;
}
tbody tr .coluna-selecionar {
  width: 40px !important;
  margin: 0px;
  padding: 3px 2px;
}
tbody tr .coluna-atributo {
  width: 250px !important;
}
.elipse {
  width: 12px;
  height: 12px;
  border-radius: 50%;
}
.texto-excluir-pai {
  text-align: center;
  text-justify: inter-word;
  font-size: 23px;
  font-weight: bold;
  color: black;
}
.texto-excluir-filho {
  text-align: center;
  text-justify: inter-word;
  font-size: 15px;
}
.btn-excluir {
  font-size: 16px;
  padding: 0px 25px;
}

.titulo-tabela {
  font-size: 18px;
}
.container-grid-table {
  border: 1px solid #707070;
  font-size: 12px;
}
.container-modal-excluir {
  width: 590px;
}
.texto-excluir-pai {
  text-align: center;
  text-justify: inter-word;
  font-size: 23px;
  font-weight: bold;
  color: black;
}
.texto-excluir-filho {
  text-align: center;
  text-justify: inter-word;
  font-size: 15px;
}
.btn-excluir {
  font-size: 16px;
  padding: 0px 25px;
}
@media (max-width: 600px) {
  .titulo-tabela {
    font-size: 14px;
    margin-bottom: 10px;
    margin-left: 0px;
  }
  .titulo-input {
    font-size: 12px;
  }
  .input {
    font-size: 12px;
  }
  .elipse {
    width: 10px;
    height: 10px;
    border-radius: 50%;
  }
  .container-modal-excluir {
    width: 100%;
    height: 250px;
    padding: 10px 10px 0px 10px;
    margin: 0px;
    border-radius: 10px;
  }
  .texto-excluir-pai {
    font-size: 17px;
  }
  .texto-excluir-filho {
    font-size: 14px;
  }
  .btn-excluir {
    font-size: 14px;
  }
}
</style>
